import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import { hasPermission, createHistory, hasAtLeastOnePermission, formatDate } from '../../../sc-utilities';
import AddressList from './AddressList';
import countries from 'i18n-iso-countries';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const Address = props => {
    const tableRef = useRef();
    const { classes, columns, userLanguage, translations, permissions } = props;

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, addressID: null, redirectPath: '' });
    const redirectHandler = (path, addressID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, addressID: addressID, redirectPath: path })
    };

    try {
        let lang = userLanguage;
        if (userLanguage.includes("zh-")) {
            lang = "zh";
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`));
    } catch (error) {
        console.log(error)
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    let visible = columns && columns['Address'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'address_load') ? <Tooltip title={translations["address_details"] || "Address details"}>
                        <IconButton
                            id={`edit_address_${rowData.AddressID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/address/edit?addressID=${rowData.AddressID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                        : null
                }
            </>
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Type ? rowData.Type : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["city"] || 'City', field: 'City',
            hidden: visible ? visible['City'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.City ? rowData.City : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["country"] || 'Country', field: 'Country',
            hidden: visible ? visible['Country'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Country ? countries?.getName(rowData?.Country, userLanguage) || rowData?.Country : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["street"] || 'Street', field: 'Street',
            hidden: visible ? visible['Street'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Street ? rowData.Street : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["street_number"] || 'Street number', field: 'StreetNumber',
            hidden: visible ? visible['StreetNumber'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.StreetNumber ? rowData.StreetNumber : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["gln"] || 'GLN', field: 'GLN',
            hidden: visible ? visible['GLN'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.GLN ? rowData.GLN : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["created_at"] || 'Created at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            filtering: true,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, ['address_load'])) {
        tableColumns.shift();
    };

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'address_list') ?
                <AddressList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(Address));